import React from 'react';
import parse from 'html-react-parser';

export default function TwoOptionArrayCard({ 
    candidate1, 
    candidate2, 
    seeMore, 
    askForVote 
}) {
  const trucateText = (text) => {
    let text2 = text;
    const myArray = text.split(".");
    if (myArray.length > 1) return parse(myArray[0] + '.');
    else return parse(text2);
  };

  return (
    <div className={"box"} key={candidate1.IDCandidato}>
      <div>
        <div className="image">
          <img src={candidate1.Foto} className="candidato" alt={candidate1.Nombre} />
        </div>
        <div className="name">{candidate1.Nombre}</div>
        <div>{trucateText(candidate1.Descripcion)}</div>
        <center>
          <button 
            className="button-candidate"  
            onClick={e => seeMore(candidate1)} 
            id={"ver" + candidate1.IDCandidato}
          >
            Ver Más
          </button>
          <div style={{color: "#003360", height: "50px"}}>
            ¿Aprueba al candidato para que forme parte de la Consejo de Administración?
          </div>
          <button 
            disabled={(candidate1.estado !== "Allow" || candidate2.estado !== "Allow") ? "disabled" : ""} 
            className={"button-candidate"}
            onClick={e => askForVote(candidate1.IDCandidato, candidate1.Nombre, e, candidate1.respuesta, "Si", candidate2.IDCandidato)} 
            id={candidate1.IDCandidato}
          >
            SI
          </button>
          <button 
            disabled={(candidate1.estado !== "Allow" || candidate2.estado !== "Allow") ? "disabled" : ""} 
            className={"no-botton button-candidate"}      
            onClick={e => askForVote(candidate2.IDCandidato, candidate2.Nombre, e, candidate2.respuesta, "No", candidate1.IDCandidato)} 
            id={candidate2.IDCandidato}
          >
            NO
          </button>
        </center>
      </div>
    </div>
  );
}
